import { getChartHistory, getResumeIndex } from '../utils/funds';
import { getSlugs, getFiles, getFilesOrganized, generateDOM } from '../utils/file-manager';
import { toggleNavigation } from '../utils/navigaton';
import { createTable } from '../utils/table';
import { exportToExcel } from '../utils/table-to-excel';

function validarEConverterJson(jsonString) {
    try {
        const jsonStringParse = JSON.parse(jsonString);

        if( typeof jsonStringParse == 'string' ) {
            return JSON.parse(jsonStringParse);
        } else {
            return jsonStringParse;
        }
    } catch (erro) {
        console.error("JSON inválido, tentando corrigir:", erro.message);

        try {
            const jsonCorrigido = JSON.parse(
                jsonString
                    .replace(/\\n/g, '')       // Remove quebras de linha escapadas
                    .replace(/\\t/g, '')       // Remove tabulações escapadas
                    .replace(/\\'/g, "'")      // Substitui aspas simples escapadas
                    .replace(/\\"/g, '"')      // Substitui aspas duplas escapadas
            );
            console.log(jsonCorrigido);
            return jsonCorrigido;
        } catch (erroCorrecao) {
            console.error("Não foi possível corrigir o JSON:", erroCorrecao.message);
            return null;
        }
    }
}

$(document).ready(function () {
    // NAVIGATION
    if( $('.js-group-toggle').length > 0 ) {
        $('.js-group-toggle').click(function (e) { 
            e.preventDefault();
            
            if( !$(this).hasClass('active') ) {
                $('.js-group-toggle').removeClass('active');
                $(this).addClass('active');
    
                $('.js-group').removeClass('active');
    
                const groupID = $(this).attr('data-group');
                const groupElem = $(`.js-group[data-group=${groupID}]`);
    
                groupElem.addClass('active');
    
                setTimeout(function () {
                    refreshObservers();
                }, 400);
            }
        });
    
        $('.js-group-toggle')[0].click();
    }
    if( $(".js-list-toggle").length > 0 ) {
        toggleNavigation(".js-list-toggle", ".js-list-toggle-prev", ".js-list-toggle-next");
    }
    // NAVIGATION END


    // function execAllRequests() {
        // SECAO GRAFICO TABELA
        (() => {
            $('[data-chart-history]').each(function (index, element) {
                const idName = $(this).attr('data-chart-history');
                const apiCode = $(this).attr('data-api');
                
                getChartHistory(idName, apiCode, "all", true);
        
                if( $(this).attr('data-table-type') == "mziq" || $("body").hasClass("postid-17383")) {
                    // 17383 = NUIF11
                    getResumeIndex(idName + "_table", apiCode);
                }
                
                if( $(this).attr('data-table-type') == "googleSheets" ) {
                    const url = $(this).attr('data-table-rentabilidade');

                    fetch(getApiUrlBase(url))
                    .then(response => response.json())
                    .then(data => {               
                        const table = $('#' + idName + '_tableSheets');
                        const year = Object.keys(data)[0];
                        const elements = data[year].elements;
                    
                        let thead = `
                            <thead>
                                <tr>
                                    <th>Fundo ${year}</th>
                                    ${Object.keys(data[year]).map(month => month !== 'elements' ? `<th>${month}</th>` : '').join('')}
                                </tr>
                            </thead>
                        `;
                    
                        // Cria a estrutura do corpo da tabela
                        let tbody = `
                            <tbody>
                                ${elements.map((element, index) => {
                                    let row = `<tr"><td>${element}</td>`;
                                    Object.keys(data[year]).forEach(month => {
                                        if (month !== 'elements') {
                                            const value = data[year][month][index];
                                            row += `<td>${value !== undefined ? (value * 100).toFixed(2) + '%' : '-'}</td>`;
                                        }
                                    });
                                    row += '</tr>';
                                    return row;
                                }).join('')}
                            </tbody>
                        `;
                    
                        table.html(thead + tbody);
                    })
                    .catch(error => {
                        console.error('Erro ao fazer requisição:', error);
                    });                
                }
                
                $(this).find('.js-filter-click').click(function() {
                    if( !$(this).hasClass('active') ) {
                        $(this).siblings('.js-filter-click').removeClass('active');
                        $(this).addClass('active');
        
                        $("#" + idName).html('<div class="c-loading mx-auto"><div></div></div>');
        
                        getChartHistory(idName, apiCode, $(this).attr('data-period'), false);
                    }
                });
            });

            // function fillTable(idName, data) {
            //     const year = 2024;
            //     const elements = data[year].elements;
            //     const yearData = data[year];
        
            //     // Iterar sobre os elementos
            //     elements.forEach((element, index) => {
            //         // Criar uma nova linha para o elemento
            //         const row = $('<tr>').css('background', 'white');
                    
            //         // Coluna ANO (apenas para o primeiro elemento)
            //         const yearCell = $('<td>').text(index === 0 ? year : '').attr('rowspan', elements.length);
            //         row.append(yearCell);
        
            //         // Coluna para o nome do elemento
            //         row.append($('<td>').text(element));
        
            //         // Adicionar as colunas para os meses (Jan, Fev, Mar, ..., Dez)
            //         Object.keys(yearData).forEach(month => {
            //             if (month !== 'elements' && month !== 'Ano' && month !== 'Inicio') {
            //                 const value = yearData[month][index];
            //                 const monthCell = $('<td>').text(value !== undefined ? (value * 100).toFixed(2) + "%" : "-");
            //                 row.append(monthCell);
            //             }
            //         });
        
            //         // Coluna ANO e INÍCIO
            //         const anoValue = yearData.Ano[index];
            //         const inicioValue = yearData.Inicio[index];
            //         row.append($('<td>').text((anoValue * 100).toFixed(2) + "%"));
            //         row.append($('<td>').text((inicioValue * 100).toFixed(2) + "%"));
        
            //         // Adicionar a linha à tabela existente
            //         $('#' + idName + '_tableSheets tbody').append(row);
            //     });
            // }
        })();
        // SECAO GRAFICO TABELA END

        // SECAO RELATORIO ARQUIVOS
        $('.js-relatorios-index').each(function (index, element) {
            const groupID = $(this).attr('data-group');
        
            if( $(this).find(".js-fm").length > 0 ) {
                const slugs = getSlugs(groupID);
            
                getFiles(slugs).then(function(response) {
                    const files = getFilesOrganized(response.data.document_metas, slugs);
            
                    generateDOM(files, $(`.js-fm[data-group=${groupID}]`).find('[data-slug]'));
                }).catch(function(error) {
                    console.error("Erro na requisição:", error);
                });
            }

            if( $(this).find(".js-fm-api").length > 0 ) {
                const $element = $(this).find(".js-fm-api");
                const apiUrl = $element.attr("data-api");
                const groupID = $element.attr("data-group");

                fetch(getApiUrlBase(apiUrl))
                .then(response => response.json())
                .then(data => {
                    const files_output = data.data.document_metas;
                    const publishedFiles = files_output.filter(file => file.is_published === true);

                    const uniqueCategories = [...new Set(publishedFiles.map(file => file.category_internal_name))];

                    $element.html(`
                        <div class="js-fm" data-group="${groupID}" data-company="0"></div>
                    `);

                    $.each(uniqueCategories, function (i, e) {
                        $element.find(".js-fm").append(`
                            <div data-slug="${e}"><div class="c-loading"><div></div></div></div>
                        `);
                    });

                    const slugs = getSlugs(groupID);
                    
                    const files = getFilesOrganized(publishedFiles, slugs);

                    generateDOM(files, $(`.js-fm[data-group=${groupID}]`).find('[data-slug]'));
                })
                .catch(error => console.error("Erro ao buscar os dados:", error));
            }
        });
        // SECAO RELATORIO ARQUIVOS END

        // SECAO FAQS
        $('.js-faq-fm').each(function () {
            const $container = $(this);
        
            let slugs;
            try {
                const slugsAttr = $container.attr('slugs');
                const parsedSlugs = JSON.parse(slugsAttr);
        
                slugs = parsedSlugs.map(item => item.id);
            } catch (error) {
                console.error("Erro ao processar 'slugs':", error, $container);
                return;
            }
        
            if (!Array.isArray(slugs) || slugs.length === 0) {
                console.warn("Nenhum slug válido encontrado para o container:", $container);
                return;
            }
            
            getFiles(slugs)
                .then(function (response) {
                    const files = response.data.document_metas;
        
                    $container.html('');

                    $.each(files, function (i, e) {
                        $container.append(`
                            <li>
                                <a href="${e.permalink}" target="_blank">
                                    <span>${e.file_title}</span>
                                    <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M18.8781 9.09L20.2881 10.5L12.9952 17.7929C12.6047 18.1834 11.9715 18.1834 11.581 17.7929L4.28809 10.5L5.69809 9.09L11.2881 14.67L11.2881 2.5H13.2881L13.2881 14.67L18.8781 9.09Z" fill="black"/><path d="M4.28809 22.5H20.2881V20.5H4.28809V22.5Z" fill="black"/></svg>
                                </a>
                            </li>
                        `);
                    });
                })
                .catch(function (error) {
                    console.error("Erro na requisição:", error);
                });
        });
        // SECAO FAQS END

        // SHEETS - HISTORICO DE COTAS
        $('[data-historico-cotas]').each(function (index, element) {
            const url = $(this).attr('data-historico-cotas');
        
            fetch(getApiUrlBase(url))
            .then(response => response.json())
            .then(data => {   
                console.log("data", data);
                
                // Mapeamento das chaves para os nomes legíveis
                const headerMapping = {
                    "data": "Data",
                    "cota_mercado": "Cota de Mercado (R$)",
                    "cota_patrimonial": "Cota Patrimonial (R$)",
                    "patrimonio_liquido": "Patrimônio Líquido (R$)",
                    "preco_fechamento": "Preço Fechamento", 
                    "indice": "Índice", 
                };

                // Altera o nome da coluna no fundo NUIF11
                $('body').hasClass('postid-17383') ? headerMapping['cota_patrimonial'] = 'Cota Patrimonial Ajustada (R$)' : null;

                if(!data.cota_mercado) {
                    data.cota_patrimonial = data.cota_patrimonial.map(item => {
                        return parseFloat(item).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    });
                } else {
                    data.cota_mercado = data.cota_mercado.map(item => {
                        return parseFloat(item).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
                    });
                }
               

                const table = createTable(headerMapping, data); 
                $(element).html(table);  // Insere a tabela no elemento  
            })
            .catch(error => {
                console.error('Erro ao fazer requisição:', error);
            });
        });
        // SHEETS - HISTORICO DE COTAS END

        // SHEETS - HISTORICO PROVENTOS
        $('[data-historico-proventos]').each(function (index, element) {
            const url = $(this).attr('data-historico-proventos');
        
            fetch(getApiUrlBase(url))
            .then(response => response.json())
            .then(data => {    
                // Mapeamento das chaves para os nomes legíveis
                const headerMapping = {
                    "data_anuncio": "Data do Anúncio",
                    "data_pagamento": "Data do Pagamento",
                    "valor_cota": "Valor do Provento",
                };
        
                const table = createTable(headerMapping, data);
                $(element).html(table);  // Insere a tabela no elemento
            })
            .catch(error => {
                console.error('Erro ao fazer requisição:', error);
            });
        });
        // SHEETS - HISTORICO PROVENTOS END
        
        // SHEETS - COMPOSICAO TABLE
        $('[data-composicao-carteira-tabela]').each(function (index, element) {
            const url = $(this).attr('data-composicao-carteira-tabela');
        
            fetch(getApiUrlBase(url))
            .then(response => response.text())
            .then(data => {    
                data = validarEConverterJson(data);

                const dataBase = (data.date && Array.isArray(data.date)) ? data.date[0] : null;

                dataBase ? $('.js-data-referencia').text(moment(dataBase).format('DD/MM/YYYY')) : null;

                const newData = Object.keys(data).reduce((acc, key) => {
                    if (key !== 'date') {
                        acc[key] = data[key];
                    }
                    return acc;
                }, {});

                // Mapeamento das chaves para os nomes legíveis
                const headerMapping = {
                    'nome' : 'Nome',
                    'valor_total' : 'Valor total (R$)',
                    'participacao' : 'Participação (%)',
                };

                // Altera o nome da coluna no fundo NUIF11
                $('body').hasClass('postid-17383') ? headerMapping['valor_total'] = 'Valor (R$ mil)' : null;
        
                const table = createTable(headerMapping, newData);
                
                $(element).html(table);

                $(element).find("tr td:nth-child(2)").each(function(i, e) {
                    let valor = parseFloat($(e).text().trim());
                
                    if (!isNaN(valor)) {
                        $(e).text(valor.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }));
                    }
                });

                $(element).find("tr td:nth-child(3)").each(function(i, e) {
                    let valor = parseFloat($(e).text().trim());
                    
                    if (!isNaN(valor)) {
                        $(e).text(valor.toFixed(2));
                    }
                });

                // SHEETS - BANNER
                if( $('.js-numerosFundoETF').length > 0 ) {
                    $('.js-numerosFundoETF').each(function (i, e) {
                        const url = $(this).attr('data-url');
                
                        fetch(getApiUrlBase(url))
                        .then(response => response.json())
                        .then(data => {   
                            let dataReferencia;
                            if( typeof data.data_referencia == 'object' ) {
                                dataReferencia = moment(data.data_referencia[0]).format('DD/MM/YYYY');
                            } else {
                                dataReferencia = moment(data.data_referencia).format('DD/MM/YYYY');
                            }

                            data.data_referencia = dataReferencia;
                    
                            const patrimonio = new Intl.NumberFormat('pt-BR', {
                                style: 'currency',
                                currency: 'BRL'
                            }).format(data.patrimonio);
                            data.patrimonio = patrimonio;

                    
                            $(e).find('[data-api]').each(function () {
                                const apiIndex = $(this).attr('data-api');
                                const value = data[apiIndex];
                    
                                if (value !== undefined) {
                                    $(this).text(value);
                                    $(this).parent().removeClass('d-none');
                                    $(this).parent().removeClass('hidden');
                                }
                            });

                            if(!dataBase) {
                                $('.js-data-referencia').text(data.data_referencia);
                            }
                
                            console.log('dataBase', dataBase)
                            console.log('data_referencia', data.data_referencia)
                        })
                        .catch(error => {
                            console.error('Erro ao fazer requisição:', error);
                        });
                    });
                } 
                // SHEETS - BANNER END
            })
            .catch(error => {
                console.error('Erro ao fazer requisição:', error);
            });
        });
        // SHEETS - COMPOSICAO TABLE END

        // SHEETS - GRAPHIC
        $('[data-composicao-carteira-grafico]').each(function (index, element) {
            const url = $(this).attr('data-composicao-carteira-grafico');
            const idName = $(this).attr('data-id');
        
            fetch(getApiUrlBase(url))
            .then(response => response.json())
            .then(data => {    
                let newSeries = []
            
                const createdSeries = (values) => {
                    for (let index = 0; index < values.data_title.length; index++) {
                        const yValue = parseFloat(values.data_porcent[index]); // 
                        newSeries.push({
                            name: `${values.data_title[index]}`,
                            y: yValue,
                            color: `${values.color_slice[index]}`
                        }, )
            
                    }
                }
            
                createdSeries(data);
            
                Highcharts.chart(idName, {
                    chart: {
                        backgroundColor: null,
                        plotBackgroundColor: null,
                        plotBorderWidth: null,
                        plotShadow: false,
                        type: 'pie',
                    },
                    title: {
                        text: '',
                        align: 'left',
                        style: {
                            color: '#FFFFFF', // Títulos em branco
                        },
                    },
                    tooltip: {
                        pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>',
                        style: {
                            fontSize: '16px'  // Define o tamanho da fonte do tooltip
                        }
                    },
                    accessibility: {
                        point: {
                            valueSuffix: '%',
                        },
                    },
                    plotOptions: {
                        pie: {
                            allowPointSelect: true,
                            cursor: 'pointer',
                            dataLabels: {
                                enabled: true,
                                format: '{point.percentage:.1f} %',
                            },
                            showInLegend: true,
                            borderWidth: 0,
                        },
                    },
                    legend: {
                        enabled: false // Desativa a legenda padrão
                    },                                
                    exporting: {
                        enabled: false,
                    },
                    series: [
                        {
                            name: 'Percentual',
                            innerSize: '50%', // Define o tamanho interno como percentual
                            size: '300px', // Define o tamanho total fixo
                            data: newSeries,
                        },
                    ],
                    credits: {
                        enabled: false,
                    },
                });

                const list = $('#' + idName + '-list');

                $.each(newSeries, function (i, e) { 
                    list.append(`
                        <li data-item="${i}">
                            <div style="background-color:${e.color};"></div>
                            <span>${e.name}</span>
                        </li>    
                    `);
                });

                list.on('click', 'li', function() {
                    const index = $(this).data('item');
                    const chart = Highcharts.charts.find(c => c.renderTo.id === idName);
                    const series = chart.series[0].data[index];

                    if (series.visible) {
                        series.setVisible(false);
                        $(this).addClass('disabled');
                    } else {
                        series.setVisible(true);
                        $(this).removeClass('disabled');
                    }
                });
            })
            .catch(error => {
                console.error('Erro ao fazer requisição:', error);
            });
        });
        // SHEETS - GRAPHIC END

        // BTN - TABLE DOWNLOAD
        $('.js-btn-downloadTable').click(function (e) { 
            e.preventDefault();
            
            exportToExcel($(this).attr('data-download'));
        });
        // BTN - TABLE DOWNLOAD END

        // CALCULADORA
        $('[data-calculadora]').each(function (index, element) { 
            const url = $(this).attr('data-calculadora');
            const father = $(this);
            console.log('Atualizado v3')
            let valorNtn_b_api = '';
            let valorIPCA_api = '';
            let valorIpca_calculator = ''; 
    
            fetch(getApiUrlBase(url)) 
                .then(response => response.json())  
                .then(infos => {
                    // 83.42
                    let createinfos = data => {
                        let maximo = data.sensibilidade.linha_max[0];
                        let minimo = data.sensibilidade.linha_min[data.sensibilidade.linha_min.length - 1];
    
                        let valorCotaInicial = data.sensibilidade.cota_mercado; // Substitua pelo valor inicial desejado
                        let cotaPatrimonial = data.sensibilidade.cota_patrimonial;
                        let agioDesagioInicial = parseFloat(data.sensibilidade.agio_desagio * 100).toFixed(1); //
                        let duration = Number(data.sensibilidade.duration.replace(",", "."));
                        let carregoPosCustos = data.sensibilidade.carrego_pos_custo * 100;
                        let valorIPCAInicial = data.sensibilidade.valor_ipca_inicial;
    
                        //Calculo GrossUP
                        let valor_ipcaNew = data.sensibilidade.valor_ipca;
                        let yield_com_gross_up = data.sensibilidade.yield_com_gross_up;
                        let premio_ntnb_com_gross_up = data.sensibilidade.premio_ntnb_com_gross_up;
    
            
                        valorNtn_b_api = data.sensibilidade.ntn_b_ipca;
                        valorIPCA_api = data.sensibilidade.valor_ipca;
    
                        $('.show-yieldGross .yieldGross').text((Math.trunc(parseFloat(yield_com_gross_up) * 10000) / 100).toFixed(2) + '%');
                        $('.show-ntnbGross .premioGross').text((Math.trunc(parseFloat(premio_ntnb_com_gross_up) * 10000) / 100).toFixed(2) + '%');
                        $('.show-valorIPCAnew .valorIPCAnew').text((Math.trunc(parseFloat(valor_ipcaNew) * 10000) / 100).toFixed(2) + '%')
    
                        //END - Calculo GrossUP
    
                        father.find('.range #valor').attr('min', minimo);
                        father.find('.range #valor').attr('max', maximo);
                        father.find('.cota_patrimonial').text(cotaPatrimonial);
                        father.find('.cota_mercado').text(valorCotaInicial);
                        father.find('#label2').text('R$ ' + parseFloat(data.sensibilidade.cota_patrimonial).toFixed(2));
                        father.find('.agio_desagio').text(agioDesagioInicial);
                        father.find('#label3').text(agioDesagioInicial);
                        father.find('.inputCota').val(parseFloat(data.sensibilidade.cota_mercado).toFixed(2));
                        let ntnbInicial = data.sensibilidade.premio_NTNB_inicial
                        let ntnbInicialPercentage = (parseFloat(ntnbInicial) * 100).toFixed(2) + '%'
                        father.find('.show-value4').text(ntnbInicialPercentage);
                        father.find('.valueIPCA').text((parseFloat(valorIPCAInicial).toFixed(2)) * 100 + '%');
                        father.find('.carrego_pos_custos').text(carregoPosCustos);
                        father.find('.duration').text(duration);
                        father.find('.ntn_ipca').text(data.sensibilidade.ntn_b_ipca);
    
                        // Adicionando linhas na tabela
                        for (let index = 0; index < data.sensibilidade.linha_max.length; index++) {
                            const max = data.sensibilidade.linha_max[index];
                            const min = data.sensibilidade.linha_min[index];
    
                            father.find('#intervalos tbody').append(`
                            <tr data-intervalo-inicio="${min}" data-intervalo-final="${max}">
                                <td class="ipca-mais-inicio">${max}</td>
                                <td class="ipca-mais-final">${min}</td>
                            </tr> 
                            `);
                        }
    
                        let valorTag = father.find('.valueIPCA').text()
    
                        let ipcaInicial = data.sensibilidade.valor_ipca_inicial * 100
    
                        father.find('.valueIPCA').text(ipcaInicial.toFixed(2) + '%');
    
                        father.find('.range #valor').val(data.sensibilidade.cota_mercado);
                    }
    
                    createinfos(infos);
    
                    const max = parseFloat(valor.getAttribute("max"));
                    const min = parseFloat(valor.getAttribute("min"));
                    const showValue = document.querySelector('.show-value');
                    const inputCota = document.querySelector('.inputCota');
                    const valorLabel2 = document.getElementById('label3');
    
                    //Cabeçalho
                    const cota_patrimonial = father.find('thead .cota_patrimonial').text();
                    const duration = father.find('thead .duration').text();
                    const carrego_pos_custos = father.find('thead .carrego_pos_custos').text();
    
                    const diff = max - min;
    
                    for (var i = 0; i <= diff; i++) {
                        const percentage = (i / diff);
                        const rangePos = i + min;
    
                        const line = document.createElement("span");
                        line.innerHTML = '<label class="value">' + rangePos + '</label>';
                        line.style.left = (percentage * 100) + "%";
    
                        ruler.appendChild(line);
    
                        if (i < diff) {
                            const numOfPoints = 5; // Define a quantidade de pontos entre cada valor (ajuste conforme necessário)
                            for (let j = 1; j <= numOfPoints; j++) {
                                const lineBetween = document.createElement("span");
                                lineBetween.classList.add('line-between');
    
                                // Calculando o posicionamento entre os valores
                                const positionBetween = (i + (j / (numOfPoints + 1))) * (100 / diff);
    
                                lineBetween.style.left = positionBetween + "%";
                                ruler.appendChild(lineBetween);
                            }
                        }
                    }
    
    
                    //Funções calculos
                    //Calculo GrossUP
                    function calcularYieldComGrossUp(ipca, valorIpcaInicial) {
                        ipca = ipca;
                        valorIpcaInicial = valorIpcaInicial;
    
                        if (isNaN(ipca) || isNaN(valorIpcaInicial)) {
                            console.error("Valores inválidos para IPCA ou rendimento.");
                            return;
                        }
                        const resultado = (1+(((1+ ipca )*(1+  valorIpcaInicial ))-1)/0.85)/(1+ ipca )-1
    
                        const percentual = Math.round(resultado * 10000) / 100;
                        $('.show-yieldGross .yieldGross').text(percentual.toFixed(2) + '%');
                    }
    
                    function calcularPremioNTNBComGrossUp(valor_ipca, valor_ipca_inicial, ntn_b_ipca) {
                        const formulaPremio = "(1+(((1+ valor_ipca )*(1+  valor_ipca_inicial ))-1)/0.85)/((1+ valor_ipca)*(1+ ntn_b_ipca ))-1";
                        const formulaPremioSubstituida = formulaPremio
                            .replace(/valor_ipca_inicial/g, valor_ipca_inicial)
                            .replace(/valor_ipca/g, valor_ipca)
                            .replace(/ntn_b_ipca/g, ntn_b_ipca);
    
                        const premioNtnbComGrossUp = eval(formulaPremioSubstituida);
    
                        const value = premioNtnbComGrossUp * 100;
    
                        $('.show-ntnbGross .premioGross').text(value.toFixed(2) + '%');
                    }
                    //END - Calculo GrossUP
    
                    function calculaAgioDesagio(valorCota, valorPatrimonial) {
                        let result = ((valorCota / valorPatrimonial) - 1) * 100
                        return result
                    }
    
                    function calcIPCA(desagio, duration, carrego_pos_custos, valorCota) {
                        const numberDesagio = desagio * 0.01;
                        const numberDuration = duration;
                        const numerCarrego = carrego_pos_custos * 0.01; 
    
    
                        const ipca = (1 - (numberDesagio) / numberDuration) * (1 + numerCarrego) - 1;
                        let result = ipca * 100;
                        father.find('.infos .show-ipca .valueIPCA').text(result.toFixed(2) + '%');
                        // father.find('.show-value4').text(result.toFixed(2) + '%');
                        valorIpca_calculator = ipca;
                        return result;
                    }
    
                    function calcPremioNtn(ipca, ipcaNTN, valorCota) {
                        let ipcaNumber = ipca / 100
                        let ipcaNTNnumber = parseFloat(ipcaNTN);
                        let calculo = (((1 + ipcaNumber) / (1 + ipcaNTNnumber)) - 1) * 100;
                        let diferenca = 0;
    
                        father.find('.show-value4').text(`${calculo.toFixed(2)}%`);
                        // father.find('.infos .show-ipca .valueIPCA').text(`${calculo.toFixed(2)}%`);
                        return
                    }
    
                    // Eventos
                    inputCota.addEventListener("change", function (e) {
                        const cursorStart = this.selectionStart;
                        const cursorEnd = this.selectionEnd;
                        const showIpca = father.find('.show-ipca .valueIPCA').text();
                        const showIpcantn = father.find('.ntn_ipca').text();
    
    
                        const decimalIndex = this.value.indexOf('.');
                        if (decimalIndex !== -1 && this.value.length - decimalIndex > 3) {
                            this.value = this.value.slice(0, decimalIndex + 3);
                        }
    
                        this.setSelectionRange(cursorStart, cursorEnd);
    
    
    
                        const input = parseFloat(this.value.replace(",", "."));
                        const minValue = min;
                        const maxValue = max;
    
                        if (input < minValue || input > maxValue) {
                            father.find('.error').text(`O valor está fora do intervalo permitido entre ${min} e ${max}`);
    
                            return;
                        } else {
                            father.find('.error').text('')
                            let valor12Result = calculaAgioDesagio(input.toFixed(2), Number(cota_patrimonial).toFixed(2))
                            valorLabel2.innerText = valor12Result.toFixed(1);
                            let ipcaFinal3 = calcIPCA(valor12Result.toFixed(2), parseFloat(duration), carrego_pos_custos, input.toFixed(2));
    
                            calcPremioNtn(ipcaFinal3, showIpcantn, valor12Result)
    
    
                            // Calculo GrossUP
                            let ipcaNew = $('.show-valorIPCAnew .valorIPCAnew').text();
                            let ntnb = $('.show-ntnbGross .premioGross').text();
                            calcularYieldComGrossUp((parseFloat(ipcaNew) / 100), valorIpca_calculator);
                
                            calcularPremioNTNBComGrossUp(valorIPCA_api, valorIpca_calculator, valorNtn_b_api);
                             //END - Calculo GrossUP
                        }
    
    
                    });
    
                    valor.addEventListener("change", function () {
                        inputCota.value = Number(this.value).toFixed(2);
                        var input = parseFloat(this.value);
                        input = input.toFixed(2);
                        const showIpca = father.find('.show-ipca .valueIPCA').text();
                        const showIpcantn = father.find('.ntn_ipca').text();
                        let valor12Result2 = calculaAgioDesagio(Number(input).toFixed(2), Number(cota_patrimonial).toFixed(2))
                        valorLabel2.innerText = valor12Result2.toFixed(1)
                        let ipcaFinal = calcIPCA(valor12Result2.toFixed(2), parseFloat(duration), carrego_pos_custos, Number(this.value).toFixed(2))
    
    
    
                        calcPremioNtn(ipcaFinal, showIpcantn, valor12Result2);
    
    
                        // Calculo GrossUP
                        let ipcaNew = $('.show-valorIPCAnew .valorIPCAnew').text();
                        let ntnb = $('.show-ntnbGross .premioGross').text();
                        calcularYieldComGrossUp((parseFloat(ipcaNew) / 100), valorIpca_calculator);
                        calcularPremioNTNBComGrossUp(valorIPCA_api, valorIpca_calculator, valorNtn_b_api);
                        //END - Calculo GrossUP
                    });
    
    
                    let programmaticChange = false;
                    inputCota.addEventListener("change", function () {
                        const minValue = min; // Substitua pelo seu valor mínimo
                        const maxValue = max; // Substitua pelo seu valor máximo
                        const showIpca = father.find('.show-ipca .valueIPCA').text();
                        const showIpcantn = father.find('.ntn_ipca').text();
    
                        const inputValue = parseFloat(this.value.replace(",", "."));
    
                        if (inputValue < minValue || inputValue > maxValue) {
                            father.find('.error').text(`O valor está fora do intervalo permitido entre ${min} e ${max}`);
                            return; // Interrompe se estiver fora do intervalo
                        } else {
                            father.find('.error').text('')
                            valor.value = inputValue;
                            let valor12Result3 = calculaAgioDesagio(inputValue.toFixed(2), Number(cota_patrimonial).toFixed(2))
                            valorLabel2.innerText = valor12Result3.toFixed(1);
                            let ipcaFinal2 = calcIPCA(valor12Result3.toFixed(4), parseFloat(duration), carrego_pos_custos, inputValue.toFixed(2));
    
    
    
                            calcPremioNtn(ipcaFinal2, showIpcantn, valor12Result3);
    
                            // Calculo GrossUP
                            let ipcaNew = $('.show-valorIPCAnew .valorIPCAnew').text();
                            let ntnb = $('.show-ntnbGross .premioGross').text();
                            calcularYieldComGrossUp((parseFloat(ipcaNew) / 100), valorIpca_calculator);
                            calcularPremioNTNBComGrossUp(valorIPCA_api, valorIpca_calculator, valorNtn_b_api);
                            // END -Calculo GrossUP
    
                            if (!programmaticChange) {
                                programmaticChange = true;
    
                                valor.dispatchEvent(new Event('input', {
                                    bubbles: true,
                                    cancelable: true
                                }));
    
                                setTimeout(() => {
                                    programmaticChange = false;
                                }, 100);
                            }
                        }
                    });
    
                    const range = document.getElementById("valor"); 
    
                    function atualizarFundo() {
                        const value = ((range.value - range.min) / (range.max - range.min)) * 100;
                        range.style.background = `linear-gradient(to right, #7626C9 0%, #7626C9 ${value}%, #fff ${value}%, #fff 100%)`;
                    }
    
                    atualizarFundo();
    
                    range.addEventListener("input", atualizarFundo); 
                })
                .catch(error => {
                    console.error('Erro ao fazer requisição:', error);
                });
            //END - Eventos
        });
        // CALCULADORA END

        // CONSOLIDADOS
        (() => {
            // Inicialmente oculta os placeholders
            const placeholders = $(".js-funds-lista").find("p:contains('[')");
            
            // Faz a requisição
            if( placeholders.length > 0 ){
                placeholders.css("visibility", "hidden");
                
                fetch(getApiUrlBase("https://nubankasset-files.mziq.com/fundos/json/consolidado_patrimonio_liquido.json"))
                .then(response => response.json())
                .then(data => {
                    // Itera sobre os placeholders
                    placeholders.each(function () {
                        const text = $(this).text(); // Texto do parágrafo
                        const match = text.match(/\[(.+):(.+)\]/); // Regex para capturar NomeFundo e propriedade
                        
                        if (match) {
                            const fundo = match[1];       // Nome do fundo (e.g., "RF Institucional")
                            const propriedade = match[2]; // Propriedade (e.g., "patrimonio_12m")
                            
                            // Verifica se o fundo e a propriedade existem no JSON
                            const valor = data[fundo]?.[propriedade] || "-";
                            
                            // Se o valor for um número, formata como moeda
                            const valorFormatado = valor !== "-" 
                                ? `R$ ${parseFloat(valor).toLocaleString('pt-BR', {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2
                                })}`
                                : "-";
                            
                            // Substitui o placeholder pelo valor formatado
                            $(this).text(valorFormatado);
                        }
                    });
                    
                    // Após preencher, torna os placeholders visíveis
                    placeholders.css("visibility", "visible");
                })
                .catch(error => console.error("Erro ao buscar os dados:", error));
            }
        })();
        // CONSOLIDADOS END

    // }
});